import { Checkbox, CheckboxProps } from '@/modules/Checkbox';

/**
 * SelectionCheckbox - Checkbox especializado para selección en tablas.
 *
 * Extiende el componente base Checkbox con las mismas props.
 * Se mantiene como wrapper para retrocompatibilidad y semántica en el contexto de tablas.
 */
export type SelectionCheckboxProps = CheckboxProps;

export const SelectionCheckbox = (props: SelectionCheckboxProps) => {
  return <Checkbox {...props} />;
};
